/* Predĺžené orbitálne kolená pre potravinárske / farmaceutické potrubia.
 * Norma: DIN 11865 (Imperial / OD-based) a DIN 11866 (Metric / DN-based).
 * Použitie: orbitálne zváranie hygienických nerezových rúr — dlhší tangens
 * (l1, l2) umožňuje vloženie orbitálnej hlavice na hranu kolena.
 * Rozmery v mm; l1/l2 = dĺžky tangenciálnych rovných úsekov, r1 = polomer ohybu.
 */

// ─── 45° ELBOWS — IMPERIAL (DIN 11865) ─────────────────────────────────
export const elbows45_imperial = [
  { size: '¼"',   d1:   6.35, s1: 0.89, l2:  50.80, r1:  14.30 },
  { size: '⅜"',   d1:   9.53, s1: 0.89, l2:  50.80, r1:  28.60 },
  { size: '½"',   d1:  12.70, s1: 1.24, l2:  57.20, r1:  27.00, note: '**' },
  { size: '½"',   d1:  12.70, s1: 1.65, l2:  57.20, r1:  28.60 },
  { size: '¾"',   d1:  19.05, s1: 1.24, l2:  57.20, r1:  26.00, note: '**' },
  { size: '¾"',   d1:  19.05, s1: 1.65, l2:  57.20, r1:  28.60 },
  { size: '1"',   d1:  25.40, s1: 1.65, l2:  57.20, r1:  38.10 },
  { size: '1½"',  d1:  38.10, s1: 1.65, l2:  63.50, r1:  57.20 },
  { size: '2"',   d1:  50.80, s1: 1.65, l2:  76.20, r1:  76.20 },
  { size: '2½"',  d1:  63.50, s1: 1.65, l2:  85.70, r1:  95.30 },
  { size: '3"',   d1:  76.20, s1: 1.65, l2:  92.10, r1: 114.30 },
  { size: '4"',   d1: 101.60, s1: 2.11, l2: 114.30, r1: 152.40 },
  { size: '6"',   d1: 152.40, s1: 2.77, l2: 158.80, r1: 228.60 },
  { size: '6"*',  d1: 152.40, s1: 2.77, l2: 222.25, r1: 228.60 },
];

// ─── 45° ELBOWS — METRIC (DIN 11866) ────────────────────────────────────
export const elbows45_metric = [
  { size: 'DN 8',    d1:  13.50, s1: 1.60, l2:  33.30, r1:  20.00 },
  { size: 'DN 10',   d1:  17.20, s1: 1.60, l2:  38.60, r1:  28.00 },
  { size: 'DN 15',   d1:  21.30, s1: 1.60, l2:  37.40, r1:  30.00 },
  { size: 'DN 20',   d1:  26.90, s1: 1.60, l2:  51.80, r1:  38.50 },
  { size: 'DN 25',   d1:  33.70, s1: 2.00, l2:  55.70, r1:  38.00 },
  { size: 'DN 32',   d1:  42.40, s1: 2.00, l2:  58.70, r1:  47.50 },
  { size: 'DN 40',   d1:  48.30, s1: 2.00, l2:  63.60, r1:  57.00 },
  { size: 'DN 50',   d1:  60.30, s1: 2.00, l2:  71.50, r1:  76.00 },
  { size: 'DN 65',   d1:  76.10, s1: 2.00, l2:  94.40, r1:  95.00 },
  { size: 'DN 80',   d1:  88.90, s1: 2.50, l2: 102.40, r1: 114.50 },
  { size: 'DN 100',  d1: 114.30, s1: 2.30, l2: 118.20, r1: 152.30 },
  { size: 'DN 150',  d1: 168.30, s1: 2.60, l2:  94.70, r1: 228.30 },
  { size: 'DN 150*', d1: 168.30, s1: 2.60, l2: 149.70, r1: 228.30 },
];

// ─── 90° ELBOWS — IMPERIAL (DIN 11865) ─────────────────────────────────
// Predĺžené 90° kolená s dvomi tangenciálnymi úsekmi l1 a l2.
export const elbows90_imperial = [
  { size: '¼"',   d1:   6.35, s1: 0.89, l1:  66.70, l2:  32.40, r1:  14.30 },
  { size: '⅜"',   d1:   9.53, s1: 0.89, l1:  66.70, l2:  38.10, r1:  28.60 },
  { size: '½"',   d1:  12.70, s1: 1.24, l1:  76.20, l2:  49.20, r1:  27.00, note: '**' },
  { size: '½"',   d1:  12.70, s1: 1.65, l1:  76.20, l2:  47.60, r1:  28.60 },
  { size: '¾"',   d1:  19.05, s1: 1.24, l1:  76.20, l2:  50.20, r1:  26.00, note: '**' },
  { size: '¾"',   d1:  19.05, s1: 1.65, l1:  76.20, l2:  47.60, r1:  28.60 },
  { size: '1"',   d1:  25.40, s1: 1.65, l1:  76.20, l2:  39.10, r1:  38.10 },
  { size: '1½"',  d1:  38.10, s1: 1.65, l1:  95.30, l2:  30.10, r1:  57.20 },
  { size: '2"',   d1:  50.80, s1: 1.65, l1: 127.70, l2:  44.50, r1:  76.20 },
  { size: '2½"',  d1:  63.50, s1: 1.65, l1: 139.70, l2:  44.40, r1:  95.30 },
  { size: '3"',   d1:  76.20, s1: 1.65, l1: 150.80, l2:  44.50, r1: 114.30 },
  { size: '4"',   d1: 101.60, s1: 2.11, l1: 203.20, l2:  60.40, r1: 152.40 },
  { size: '6"',   d1: 152.40, s1: 2.77, l1: 292.10, l2:  63.50, r1: 228.60 },
  { size: '6"*',  d1: 152.40, s1: 2.77, l1: 353.60, l2: 127.00, r1: 228.60 },
];

// ─── 90° ELBOWS — METRIC (DIN 11866) ────────────────────────────────────
export const elbows90_metric = [
  { size: 'DN 4',    d1:   6.00, s1: 1.00, l1:  40.00 },
  { size: 'DN 6',    d1:   8.00, s1: 1.00, l1:  45.00 },
  { size: 'DN 8',    d1:  10.00, s1: 1.00, l1:  45.00 },
  { size: 'DN 8*',   d1:  10.00, s1: 1.00, l1:  50.00 },
  { size: 'DN 10',   d1:  12.00, s1: 1.00, l1:  51.00 },
  { size: 'DN 10',   d1:  13.00, s1: 1.50, l1:  51.00 },
  { size: 'DN 15',   d1:  18.00, s1: 1.50, l1:  51.00 },
  { size: 'DN 15',   d1:  19.00, s1: 1.50, l1:  60.00 },
  { size: 'DN 20',   d1:  23.00, s1: 1.50, l1:  65.00 },
  { size: 'DN 25',   d1:  28.00, s1: 1.50, l1:  90.00 },
  { size: 'DN 25',   d1:  29.00, s1: 1.50, l1:  90.00 },
  { size: 'DN 32',   d1:  35.00, s1: 1.50, l1:  95.00 },
  { size: 'DN 40',   d1:  41.00, s1: 1.50, l1: 100.00 },
  { size: 'DN 50',   d1:  53.00, s1: 1.50, l1: 110.00 },
  { size: 'DN 65',   d1:  70.00, s1: 2.00, l1: 120.00 },
  { size: 'DN 80',   d1:  85.00, s1: 2.00, l1: 145.00 },
  { size: 'DN 100',  d1: 104.00, s1: 2.00, l1: 155.00 },
  { size: 'DN 150',  d1: 154.00, s1: 2.00, l1: 225.00 },
];

// ** Wall thickness does not comply with DIN 11865 / DIN 11866 (custom).
// *  Extended version — longer tangent for orbital head clearance.
